import React, { useEffect } from 'react'
import { SEO, SITE_URL } from '../../constants';
import { SectionMentorAbout } from './mentor/section-mentor.jsx';


import { useSEO } from '../../hooks/useSEO';

export const PageMentor = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const seo = {
    ...SEO.mentor,
    schemaLD: {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "Менторинг Марии Бурлаковой",
      "description": "Менторинг от руководителя разработки в бигтехе. Помогу наладить процессы в команде, научиться системному мышлению, эффективному управлению и принятию решений.",
      "url": `${SITE_URL}/mentor`,
      "image": `${SITE_URL}/og-image-mentor.png`,
      "provider": {
        "@type": "Person",
        "name": "Мария Бурлакова",
        "jobTitle": "Руководитель разработки", 
        "description": "Руководитель разработки, внутренний и внешний ментор."
      },
      "serviceType": "Менторинг руководителей и команд разработки",
      "areaServed": "Россия",
      "offers": {
        "@type": "Offer",
        "category": "Professional Development",
        "description": "Индивидуальный менторинг по системному мышлению, agile, управлению командой"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Темы менторинга",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Системное мышление и процессы"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Agile и Scrum"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Управление командой"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Принятие решений"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Личностный рост"
            }
          }
        ]
      }
    }
  };

  useSEO(seo);

  return (
    <div>
      <SectionMentorAbout />
    </div>
  )
}
